var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.local_filters)?_c('GenericExplorer',{attrs:{"filters":_vm.local_filters,"views":_vm.available_views(_vm.is_mobile, _vm.computer_view_props),"headless":""},on:{"update":_vm.update_filters}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }